import { useDispatch } from 'react-redux';
import allActions from '../../actions/product_builder';
import { Button } from '@material-ui/core';
import { isPremiumOption } from '../../utils/isPremium';
import generateNameForOption from '../../utils/generateDispalyedName';
import buttons from '../../styles/buttons.module.css';
import layout from '../../styles/layout.module.css';
const ArtworkExcerpt = ({ faceplate, setSelected, isCurrent, artwork, currentSide, disabled }) => {
    const dispatch = useDispatch();
    let value = generateNameForOption(artwork);
    const updateArtwork = () => {
        if (currentSide === 'both') {
            if (!isPremiumOption(faceplate.leftOption) && !isPremiumOption(faceplate.rightOption)) {
                dispatch(allActions.artworkActions.setActiveArtwork(artwork));
                dispatch(allActions.customLayerActions.resetCustomLayer({}));
                dispatch(allActions.priceActions.setBothArtworkPrice(artwork));
            } else if (!isPremiumOption(faceplate.leftOption)) {
                dispatch(allActions.artworkActions.setLeftArtwork(artwork));
                dispatch(allActions.priceActions.setLeftArtworkPrice(artwork));
            } else if (!isPremiumOption(faceplate.rightOption)) {
                dispatch(allActions.artworkActions.setRightArtwork(artwork));
                dispatch(allActions.priceActions.setRightArtworkPrice(artwork));
            }
            setSelected(value);
        } else if (currentSide === 'left') {
            dispatch(allActions.customLayerActions.resetLeftCustomLayer({}));
            dispatch(allActions.artworkActions.setLeftArtwork(artwork));
            dispatch(allActions.priceActions.setLeftArtworkPrice(artwork));
            setSelected(value);
        } else {
            dispatch(allActions.customLayerActions.resetRightCustomLayer({}));
            dispatch(allActions.artworkActions.setRightArtwork(artwork));
            dispatch(allActions.priceActions.setRightArtworkPrice(artwork));
            setSelected(value);
        }
    };

    {
        return (
            <Button
                disableRipple={true}
                disabled={disabled}
                className={layout.pickerBtnContainer}
                onClick={() => {
                    updateArtwork();
                }}
                onMouseEnter={() => setSelected(generateNameForOption(artwork))}
                onMouseLeave={() => setSelected(null)}>
                <img
                    src={artwork.iconImage}
                    alt={artwork.displayName}
                    className={isCurrent ? buttons.btnCircleActive : buttons.btnCircle}
                />
            </Button>
        );
    }
};

export default ArtworkExcerpt;
